import { ListingPopularity } from "@t/Listing"
import { Like } from "@css/icons/Like"
import { Eye } from "@css/icons/eye"
import css from "@css/modules/HottestDeals.module.scss"
import { Spin, Tooltip } from "antd"
import { useDealsContext } from "./context"
import useSWR from "swr"
import { getHotDealsPopularity } from "@lib/api/hot-deals"
import { useMemo } from "react"

function TooltipContent({ permanentFavorites, permanentViews, id }: ListingPopularity) {
    const { time } = useDealsContext()
    const { data = { favorites: 0, views: 0 }, isLoading } = useSWR(id ? `popularity${id}_${time}` : null, () => getHotDealsPopularity({ id, time }))
    return (
        <div className={css.tooltipContent}>
            <div>
                <h3>
                    <Eye /> Views
                </h3>
                <div className={css.tooltipRow}>
                    <div>
                        <span>Total:</span> {permanentViews || 0}
                    </div>
                    <div>
                        <span>{time} Days:</span> {isLoading ? <Spin /> : data.views || 0}
                    </div>
                </div>
            </div>
            <div>
                <h3>
                    <Like fill="#CC78FF" />
                    Favorites
                </h3>
                <div className={css.tooltipRow}>
                    <div>
                        <span>Total:</span> {permanentFavorites || 0}
                    </div>
                    <div>
                        <span>{time} Days:</span> {isLoading ? <Spin /> : data.favorites || 0}
                    </div>
                </div>
            </div>
        </div>
    )
}

export function ViewsColumn(props: ListingPopularity) {
    const { permanentFavorites, permanentViews } = props
    const renderTooltip = useMemo(() => <TooltipContent {...props} />, [props])
    const body = (
        <div className={css.viewsColumn}>
            <span>
                <Eye /> {permanentViews || 0} Views <br />
            </span>
            <span>
                <Like fill="#CC78FF" /> {permanentFavorites || 0} Favs
            </span>
        </div>
    )
    if (props.id) return body
    return (
        <Tooltip placement="top" title={renderTooltip} overlayClassName={css.viewsTooltip}>
            {body}
        </Tooltip>
    )
}
